import styled from "styled-components/macro";

export const StyledExpenseWrapper = styled.div`
  && {
    padding: 10px 20px 30px 20px;
  }
`;

export const StyledHeader = styled.div`
  && {
    display: flex;
    justify-content: space-between;
    color: #000000;
  }
`;

export const StyledHeaderText = styled.div`
  && {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
  }
`;

export const StyledHeaderTotal = styled.div`
  && {
    font-family: Roboto Mono;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 21px;
    align-items: center;
  }
`;

export const StyledExpensItem = styled.div`
  && {
    display: flex;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    justify-content: space-between;
    color: #5f6368;
    padding-top: 8px;
  }
`;

export const StyledItem = styled.div`
  && {
    font-family: Work Sans;
    line-height: 14px;
  }
`;

export const StyledTotal = styled.div`
  && {
    font-family: Roboto Mono;
    line-height: 16px;
  }
`;

export const StyledTotalButton = styled.div`
  && {
    background: #fafafa;
    border: 0.5px solid #005aa9;
    height: 35px;
    padding: 0 10px;
    display: flex;
    align-items: center;
  }
`;

export const StyledText = styled.div`
  && {
    font-family: Space Mono;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 30px;
    color: #005aa9;
  }
`;

export const StyledStatusWrapper = styled.div`
  && {
    display: flex;
    justify-content: center;
  }
`;

export const StyledNetIncomeWrapper = styled.div`
  && {
    margin-top: 40px;
  }
`;

export const StyledDebtServiceWrapper = styled.div`
  && {
    margin-top: 40px;
  }
`;

export const StyledServiceItem = styled.div`
  && {
    display: flex;
    justify-content: space-between;
    color: #000000;
    padding: 8px 0px;
  }
`;

export const StyledServiceName = styled.div`
  && {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
  }
`;

export const StyledServiceTotal = styled.div`
  && {
    font-family: Roboto Mono;
    line-height: 16px;
    font-size: 16px;
    line-height: 21px;
  }
`;

export const StyledServiceMessage = styled.div`
  && {
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #5f6368;
  }
`;

export const StyledStatus = styled.div`
  && {
    width: 350px;
    display: flex;
    align-items: center;
  }
`;

export const StyledStatusHeader = styled.div`
  && {
    font-family: Work Sans;
    font-style: normal;
    text-align: center;
    padding: 10px 0;
  }
`;

export const StyledStatusBody = styled.div`
  && {
    font-family: Work Sans;
    font-style: normal;
    text-align: center;
    padding: 10px 0;
  }
`;

export const StyledStatusTotal = styled.div`
  && {
    font-family: Space Mono;
    font-weight: normal;
    font-size: 24px;
    line-height: 36px;
    color: #005aa9;
  }
`;

export const StyledStatusName = styled.div`
  && {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #5f6368;
  }
`;

export const StyledStatusReq = styled.div`
  && {
    font-weight: 600;
    font-size: 18px;
    line-height: 21px;
    color: #5f6368;
    text-transform: capitalize;
  }
`;

export const StyledCardContent = styled.div`
  && {
    font-family: Work Sans;
    font-style: normal;
    color: #000000;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px 8px;
    width: 310px;
    margin-bottom: 40px;
  }
`;

export const StyledCardTitle = styled.div`
  && {
    font-weight: 500;
    font-size: 17px;
    line-height: 19px;
    text-align: left;
    margin-bottom: 0.5em;
  }
`;

export const StyledCardReport = styled.div`
  && {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 2px 0;
  }
`;

export const StyledReportLabel = styled.div`
  && {
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
  }
`;

export const StyledReportDate = styled.div`
  && {
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
  }
`;

export const MultiLineItemHeader = styled.div`
  width: 97%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 3%;
  padding-top: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
`;

export const MultiLineItemHeaderName = styled.div`
  font-family: Work Sans;
  line-height: 14px;
  font-size: 13px;
`;

export const MultiLineItemHeaderValue = styled.div`
  font-family: Roboto Mono;
  line-height: 16px;
  font-size: 13px;
`;
